import React, { useCallback, useState, useMemo } from "react";
import IconButton from "@material-ui/core/IconButton";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { TextInput } from "../UIkit";

const useStyles = makeStyles({
  iconCell: {
    padding: 0,
    height: 48,
    width: 48,
  },
  checkIcon: {
    float: "right",
  },
  inputText: {
    display: "flex",
  },
});

const SetBasesArea = (props) => {
  const classes = useStyles();
  const [index, setIndex] = useState(0),
    [id, setId] = useState(""),
    [bid, setBid] = useState(""),
    [name, setName] = useState("");

  const [editingIndex, setEditingIndex] = useState(-1);

  const inputBid = useCallback(
    (event) => {
      setBid(event.target.value);
    },
    [setBid]
  );

  const inputName = useCallback(
    (event) => {
      setName(event.target.value);
    },
    [setName]
  );

  const addBase = (index, bid, name) => {
    if (bid === "" || name === "") {
      return false;
    } else {
      if (index === props.bases.length) {
        props.setBases((prevState) => [
          ...prevState,
          { id: "", bid: bid, name: name },
        ]);
        setIndex(index + 1);
        setBid("");
        setName("");
      } else {
        const newBases = props.bases;
        newBases[index] = {
          ...newBases[index],
          bid: bid,
          name: name,
        };
        props.setBases(newBases);
        setIndex(newBases.length);
        setBid("");
        setName("");
      }
      setEditingIndex(-1);
    }
  };

  const editBase = (index, bid, name) => {
    setIndex(index);
    setBid(bid);
    setName(name);
    setEditingIndex(index); // 編集中の行をセット
  };

  const deleteBase = (deleteIndex) => {
    const newBases = props.bases.filter((item, i) => i !== deleteIndex);
    props.setBases(newBases);
  };
  const memoIndex = useMemo(() => {
    setIndex(props.bases.length);
  }, [props.bases.length]);

  return (
    <div aria-label="拠点名設定">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          {/* ヘッダー部分はそのまま */}
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>拠点名</TableCell>
              <TableCell className={classes.iconCell} />
              <TableCell className={classes.iconCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {props.bases.length > 0 &&
              props.bases.map((item, i) => (
                <React.Fragment key={i}>
                  {/* 通常の行 */}
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {item.bid}
                    </TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell className={classes.iconCell}>
                      <IconButton
                        className={classes.iconCell}
                        onClick={() => editBase(i, item.bid, item.name)}
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell className={classes.iconCell}>
                      <IconButton
                        className={classes.iconCell}
                        onClick={() => deleteBase(i)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                  {/* 編集中の行の場合、入力フィールドをここに表示 */}
                  {editingIndex === i && i !== props.bases.length - 1 && (
                    // <TableRow>
                    //     {/* 入力フィールド */}
                    //     <TableCell colSpan={4}>
                    //         {/* ここにTextInputコンポーネント */}
                    //         {/* ... */}
                    //     </TableCell>
                    // </TableRow>
                    <TableRow>
                      <TableCell colSpan={4}>
                        <div>
                          <div className={classes.inputText}>
                            <TextInput
                              fullWidth={false}
                              label={"ID"}
                              multiline={false}
                              required={true}
                              onChange={inputBid}
                              minRows={1}
                              value={bid}
                              type={"text"}
                            />
                            <TextInput
                              fullWidth={false}
                              label={"拠点名"}
                              multiline={false}
                              required={true}
                              onChange={inputName}
                              minRows={1}
                              value={name}
                              type={"text"}
                            />
                          </div>
                        </div>
                        <IconButton
                          className={classes.checkIcon}
                          onClick={() => addBase(index, bid, name)}
                        >
                          <CheckCircleIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
        {/* 編集中の行がない場合、入力フィールドを通常通りここに表示 */}
        {(editingIndex === -1 || editingIndex === props.bases.length - 1) && (
          <>
            <div>
              <div className={classes.inputText}>
                <TextInput
                  fullWidth={false}
                  label={"ID"}
                  multiline={false}
                  required={true}
                  onChange={inputBid}
                  minRows={1}
                  value={bid}
                  type={"text"}
                />
                <TextInput
                  fullWidth={false}
                  label={"拠点名"}
                  multiline={false}
                  required={true}
                  onChange={inputName}
                  minRows={1}
                  value={name}
                  type={"text"}
                />
              </div>
            </div>
            <IconButton
              className={classes.checkIcon}
              onClick={() => addBase(index, bid, name)}
            >
              <CheckCircleIcon />
            </IconButton>
          </>
        )}
      </TableContainer>
      <div className="module-spacer--small" />
    </div>
  );
};

export default SetBasesArea;
